// extracted by mini-css-extract-plugin
export default {"modalContainer":"bq6GNyOfYYsOLhpOdgTu","addClientButton":"rrbcYTPj_Tn71gNRdN6Q"};